import { useState, useEffect } from "react";
import "./user-details.css";
import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { ThreeDot } from "../../../assets/images";
import { Button, Dropdown, Form, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import moment from "moment";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const UserDetails = () => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [changeEmailModal, setChangeEmailModal] = useState(false);
  const [userEmailGet, setuserEmailGet] = useState(null);
  const [passwordShowHide, setpasswordShowHide] = useState(null);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");

  const [user_id, setUser_id] = useState(null);
  const [resetPassword, setResetPassword] = useState(false);
  const [input, setInput] = useState({
    new_pass: "",
    conf_pass: "",
  });
  const [error, setError] = useState({
    new_pass: "",
    conf_pass: "",
  });
  const [changeEmailInput, setchangeEmailInput] = useState({
    secondaryEmail: "",
    isPrimaryEmail: false,
  });
  const [changeEmailInputerror, setchangeEmailInputError] = useState({
    secondaryEmail: "",
  });

  const [csvData, setCsvData] = useState([]);

  const allMembers = () => {
    let allMembers = members.map((item, i) => {
      return {
        id: i + 1,
        uId: item.id,
        name: item.name,
        arriviaUserId: item.arriviaUserId,
        email: item.email,
        userName: item.userName,
        phone: item.phone,
        date: item.createdAt,
        idTV: item.id,
        createdAt: item.createdAt,
        status: item.status,
        arriaviaStatus: item.arriaviaStatus,
        secondaryEmail: item.secondaryEmail,
        isLoginWithSecondaryEmail: item.isLoginWithSecondaryEmail,
        passwordRaw: item.passwordRaw,
        commissionType: item.commissionType,
        affiliateDetails: item.affiliateDetails,
        affId: item.affId,
        packageDetails: item.packageDetails,

        //  (
        //   <div
        //     className={
        //       item.status == true ? "status_tran compl" : "status_tran icompl"
        //     }
        //   >
        //     {item.status}
        //   </div>
        // ),
      };
    });
    return allMembers;
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };

  const getMembers = async () => {
    setLoading(true);
    axios
      .post(
        `/get-users/?limit=${limit}&page=${page}&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);

        console.error(err);
      });
  };

  const arriviaUserActiveInactive = (id, type) => {
    setLoading(true);
    let url;
    if (type === "active") {
      url = "/arrivai-active-user/" + id + "/tv";
    } else {
      url = "/arrivai-deactive-user/" + id + "/tv";
    }

    axios
      .get(url, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          getMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

    const activeInactiveUser = (id, statusType) => {
    setLoading(true);

    axios
      .post("/active-inactive-tvuser", { id }, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          // getMembers();
          // alert(statusType);
          // if (statusType === "active" || statusType === "inactive") {
          //   arriviaUserActiveInactive(id, statusType);
          // } else {
          //   getMembers();
          // }
          getMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "100px",
    },
    {
      name: "TVID",
      selector: (row) => row.idTV,
      sortable: true,
      width: "250px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "400px",
    },
    {
      name: "Secondary Email",
      selector: (row) => (row.secondaryEmail) ? row.secondaryEmail : "N/A",
      sortable: true,
      width: "400px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "200px",
    },
    {
      name: "UserName",
      selector: (row) => row.userName,
      sortable: true,
      width: "200px",
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      width: "200px",
    },
    {
      name: "Plan Name",
      selector: ({ packageDetails }) => packageDetails?.stripePlanName,
      width: "300px",
    },
    {
      name: "Plan Price",
      selector: ({ packageDetails }) =>
        packageDetails?.packagePrice ? "$" + packageDetails?.packagePrice : "",
      width: "100px",
    },
    {
      name: "Plan Expire",
      selector: ({ packageDetails }) => packageDetails?.expireDate,
      width: "100px",
    },
    {
      name: "Plan Status",
      selector: ({ isSubscriptionCanceled }) =>
        isSubscriptionCanceled ? "Canceled" : "Active",
      width: "100px",
    },
    {
      name: "Login Date",
      // selector: ({ sessionDetails }) =>
      //   sessionDetails.loginDate
      //     ? moment(sessionDetails.loginDate).format("MM-DD-YYYY")
      //     : "",
      selector: () => "",
      width: "100px",
    },
    {
      name: "arriviaUserId",
      selector: (row) => row.arriviaUserId,
      sortable: true,
      width: "100px",
    },
    {
      name: "Affiliate",
      selector: (row) =>
        row.affiliateDetails[0] ? row.affiliateDetails[0].name : "",
      sortable: true,
      width: "200px",
    },
    {
      name: "Direct Deposit",
      selector: (row) =>
        row.commissionType === "Direct Deposit" ? "Yes" : "No",
      sortable: true,
      width: "200px",
    },
    {
      name: "Created At",
      selector: (row) => moment(row.date).format("MM-DD-YYYY"),
      sortable: true,
      width: "200px",
    },
    {
      name: "Password",
      selector: (row) => (
        <div>
          {passwordShowHide === row.id ? (
            <>
              <span>{row.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row.id);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "status",
    //   selector: (row) => row.status,
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          {/* <Dropdown.Menu popperConfig={popperConfig}> */}
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                setResetPassword(true);
                setUser_id(row.idTV);
              }}
            >
              Reset Password
            </div>
             <div
              className={`dropdown-item ${row?.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row?.uId, row?.arriaviaStatus !== '' ? 'active' : "");
              }}
            >
              Active
            </div>
            <div
              className={`dropdown-item ${!row?.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row?.uId, row?.arriaviaStatus !== '' ? 'inactive' : "");
              }}
            >
              Inactive
            </div>
            {/* {row.arriaviaStatus != "" ? (
              <>
                {row.arriaviaStatus == "Active" ? (
                  <>
                    <div
                      className="dropdown-item"
                      role="button"
                      onClick={() => {
                        arriviaUserActiveInactive(row.uId, "inactive");
                      }}
                    >
                      Arrivia Inactive
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="dropdown-item"
                      role="button"
                      onClick={() => {
                        arriviaUserActiveInactive(row.uId, "active");
                      }}
                    >
                      Arrivia Active
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )} */}
            {/* <div
            className={`dropdown-item ${row.status ? "disabled" : ""}`}
            role="button"
            onClick={() => {
              // activeInactiveUser(row.id);
            }}
          >
            Active
          </div>
          <div
            className={`dropdown-item ${!row.status ? "disabled" : ""}`}
            role="button"
            onClick={() => {
              // activeInactiveUser(row.id);
            }}
          >
            Inactive
          </div> */}
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                setChangeEmailModal(true);
                setUser_id(row.uId);
                setuserEmailGet(row.email);
                setchangeEmailInput({
                  secondaryEmail: row.secondaryEmail ? row.secondaryEmail : "",
                  isPrimaryEmail: row.isLoginWithSecondaryEmail ? true : false,
                });
              }}
            >
              Change Email
            </div>
            <div
              className="dropdown-item cls"
              role="button"
              onClick={() => {
                history.push(`/edit-affiliate/${row.affId}`);
              }}
            >
              Change Affiliate
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "200px",
    },
  ];

  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const handelChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handelChangeEmail = (e) => {
    //e.preventDefault();
    let { name, value } = e.target;
    if (name == "isPrimaryEmail") {
      if (e.target.checked) {
        setchangeEmailInput({
          isPrimaryEmail: true,
          secondaryEmail: changeEmailInput.secondaryEmail,
        });
      } else {
        setchangeEmailInput({
          isPrimaryEmail: false,
          secondaryEmail: changeEmailInput.secondaryEmail,
        });
      }
    } else {
      setchangeEmailInput({
        secondaryEmail: value,
        isPrimaryEmail: changeEmailInput.isPrimaryEmail,
      });
    }
  };

  const resetPasswordFunction = (e) => {
    e.preventDefault();

    if (input.new_pass !== input.conf_pass) {
      setError({
        ...error,
        conf_pass: "Password and Confirm password not match.",
      });
    } else {
      setError({
        ...error,
        conf_pass: "",
      });

      let { new_pass, conf_pass } = input;

      const formData = {
        id: user_id,
        new_pass,
        conf_pass,
      };

      setError({});
      setInput({});
      setResetPassword(false);
      setUser_id(null);

      setLoading(true);

      axios
        .post("/reset-tvuser-password", formData, adminConfig())
        .then((res) => {
          setLoading(false);
          if (res.data.status) {
            message.success(res.data.message);
          } else {
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  };

  const changeEmailSubmitFunction = (e) => {
    e.preventDefault();

    if (changeEmailInput.secondaryEmail === "") {
      setchangeEmailInputError({
        ...changeEmailInputerror,
        secondaryEmail: "Email is mandatory.",
      });
    } else {
      setLoading(true);
      const formData = {
        uid: user_id,
        secondaryEmail: changeEmailInput.secondaryEmail,
        isPrimaryEmail: changeEmailInput.isPrimaryEmail,
      };

      setchangeEmailInputError({});
      setchangeEmailInput({});
      setChangeEmailModal(false);
      setUser_id(null);
      setuserEmailGet(null);

      axios
        .post("/tv-user-email-change", formData, adminConfig())
        .then((res) => {
          if (res.data.status) {
            setLoading(false);
            getMembers();
            message.success(res.data.message);
          } else {
            setLoading(false);
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          message.error("something went wrong!");
          console.error(err);
        });
    }
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(`/get-csv-users?search=${search}`, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            TVID: member.id,
            Email: member.email,
            SecondaryEmail: (member?.secondaryEmail) ? member.secondaryEmail : "N/A",
            Name: member.name,
            UserName: member.userName,
            Phone: member.phone,
            PlanName: member.packageDetails?.stripePlanName,
            PlanPrice: member.packageDetails?.packagePrice
              ? "$" + member.packageDetails?.packagePrice
              : "",
            PlanExpire: member.packageDetails?.expireDate,
            PlanStatus: member.isSubscriptionCanceled ? "Canceled" : "Active",
            LoginDate: "",
            arriviaUserId: member.arriviaUserId,
            Affiliate: member.affiliateDetails[0]
              ? member.affiliateDetails[0].name
              : "",
            DirectDeposit:
              member.commissionType === "Direct Deposit" ? "Yes" : "No",

            createdAt: moment(member.date).format("MM-DD-YYYY"),
            Password: member.passwordRaw,
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "TVID", key: "TVID" },
    { label: "Email", key: "Email" },
    { label: "Secondary Email", key: "SecondaryEmail" },
    { label: "Name", key: "Name" },
    { label: "UserName", key: "UserName" },
    { label: "Phone", key: "Phone" },
    { label: "Plan Name", key: "PlanName" },
    { label: "Plan Price", key: "PlanPrice" },
    { label: "Plan Expire", key: "PlanExpire" },
    { label: "Plan Status", key: "PlanStatus" },
    { label: "Login Date", key: "LoginDate" },
    { label: "Arrivia User Id", key: "arriviaUserId" },
    { label: "Affiliate", key: "Affiliate" },
    { label: "DirectDeposit", key: "DirectDeposit" },
    { label: "createdAt", key: "createdAt" },
    { label: "Password", key: "Password" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <Modal show={resetPassword}>
        <Modal.Header>
          <h4>Reset Password</h4>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={resetPasswordFunction}>
            <Form.Group className="mt-2">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                name="new_pass"
                required
                value={input.new_pass}
                type="password"
                onChange={handelChange}
                placeholder="Type New Password"
              />
            </Form.Group>
            <Form.Group className="mt-2">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                name="conf_pass"
                required
                value={input.conf_pass}
                type="password"
                onChange={handelChange}
                placeholder="Type Confirm Password"
              />
              <p>{error.conf_pass}</p>
            </Form.Group>

            <div className="modal_footer_button mt-5">
              <Button
                onClick={() => {
                  setError({});
                  setInput({});
                  setResetPassword(false);
                  setUser_id(null);
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </Button>
              <Button type="submit" className="btn btn-primary ml-3">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={changeEmailModal}>
        <Modal.Header>
          <h4>Change Email</h4>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={changeEmailSubmitFunction}>
            <Form.Group className="mt-2">
              <Form.Label>Email</Form.Label>
              <Form.Control value={userEmailGet} type="text" disabled />
            </Form.Group>
            <Form.Group className="mt-2">
              <Form.Label>Secondary Email</Form.Label>
              <Form.Control
                name="secondaryEmail"
                required
                value={changeEmailInput.secondaryEmail}
                type="email"
                onChange={handelChangeEmail}
                placeholder="Type Secondary Email"
              />
              <input
                type="checkbox"
                name="isPrimaryEmail"
                onChange={handelChangeEmail}
                checked={changeEmailInput.isPrimaryEmail ? true : false}
              />{" "}
              Do you want to make secondary email the primary email address?
            </Form.Group>

            <div className="modal_footer_button mt-5">
              <Button
                onClick={() => {
                  setchangeEmailInputError({});
                  setchangeEmailInput({});
                  setChangeEmailModal(false);
                  setUser_id(null);
                  setuserEmailGet(null);
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </Button>
              <Button type="submit" className="btn btn-primary ml-3">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Registered TV Users List</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or email or username"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={!search}
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`tripvale_user.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={allMembers()}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={members.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
export default UserDetails;
